import { Box, Button, Modal, SpaceBetween, FormField, Select } from '@amzn/awsui-components-react';
import PropTypes from 'prop-types';
import React from 'react';

const TestCampaignModal = ({
  visible,
  onDismiss,
  onSend,
  selectedEmail,
  onEmailChange,
  emailOptions,
  isLoading,
  isSending,
}) => {
  return (
    <Modal
      visible={visible}
      onDismiss={onDismiss}
      header="Test campaign"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={onDismiss}>
              Cancel
            </Button>
            <Button variant="primary" onClick={onSend} disabled={!selectedEmail || isSending}>
              Send
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      <SpaceBetween size="m">
        <Box>Select the email address where you want to receive the test campaign.</Box>
        <FormField label="Email">
          <Select
            selectedOption={selectedEmail}
            onChange={({ detail }) => onEmailChange(detail.selectedOption)}
            options={emailOptions}
            placeholder="Choose an email address"
            loading={isLoading}
          />
        </FormField>
      </SpaceBetween>
    </Modal>
  );
};

TestCampaignModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onSend: PropTypes.func.isRequired,
  selectedEmail: PropTypes.object,
  onEmailChange: PropTypes.func.isRequired,
  emailOptions: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isSending: PropTypes.bool.isRequired,
};

export default TestCampaignModal;
